import { render, staticRenderFns } from "./OngoingBadge.vue?vue&type=template&id=5b8419b9&scoped=true&"
import script from "./OngoingBadge.vue?vue&type=script&lang=js&"
export * from "./OngoingBadge.vue?vue&type=script&lang=js&"
import style0 from "./OngoingBadge.vue?vue&type=style&index=0&id=5b8419b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8419b9",
  null
  
)

export default component.exports